// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 31 hooks for backend/statements.

import { useBackend } from '../useBackend'

/** POST /api/statements/confirmScheduleUpload */
export function useConfirmScheduleUpload<T = any>() {
  return useBackend<T>('statements/confirmScheduleUpload')
}

/** POST /api/statements/getCoverageGaps */
export function useGetCoverageGaps<T = any>() {
  return useBackend<T>('statements/getCoverageGaps')
}

/** POST /api/statements/getDriveWatch */
export function useGetDriveWatch<T = any>() {
  return useBackend<T>('statements/getDriveWatch')
}

/** POST /api/statements/getEarningsValidationCoverage */
export function useGetEarningsValidationCoverage<T = any>() {
  return useBackend<T>('statements/getEarningsValidationCoverage')
}

/** POST /api/statements/getEvidenceCoverage */
export function useGetEvidenceCoverage<T = any>() {
  return useBackend<T>('statements/getEvidenceCoverage')
}

/** POST /api/statements/getEvidenceExtract */
export function useGetEvidenceExtract<T = any>() {
  return useBackend<T>('statements/getEvidenceExtract')
}

/** POST /api/statements/getFleetStateSummary */
export function useGetFleetStateSummary<T = any>() {
  return useBackend<T>('statements/getFleetStateSummary')
}

/** POST /api/statements/getMaintenanceVariance */
export function useGetMaintenanceVariance<T = any>() {
  return useBackend<T>('statements/getMaintenanceVariance')
}

/** POST /api/statements/getOwnerDocumentPack */
export function useGetOwnerDocumentPack<T = any>() {
  return useBackend<T>('statements/getOwnerDocumentPack')
}

/** POST /api/statements/getOwnerDocumentPackSummary */
export function useGetOwnerDocumentPackSummary<T = any>() {
  return useBackend<T>('statements/getOwnerDocumentPackSummary')
}

/** POST /api/statements/getOwnerStatementEmailPreview */
export function useGetOwnerStatementEmailPreview<T = any>() {
  return useBackend<T>('statements/getOwnerStatementEmailPreview')
}

/** POST /api/statements/getOwnerStatementIndex */
export function useGetOwnerStatementIndex<T = any>() {
  return useBackend<T>('statements/getOwnerStatementIndex')
}

/** POST /api/statements/getScheduleUpload */
export function useGetScheduleUpload<T = any>() {
  return useBackend<T>('statements/getScheduleUpload')
}

/** POST /api/statements/getStatementLineEvidence */
export function useGetStatementLineEvidence<T = any>() {
  return useBackend<T>('statements/getStatementLineEvidence')
}

/** POST /api/statements/getStatementLineProvenance */
export function useGetStatementLineProvenance<T = any>() {
  return useBackend<T>('statements/getStatementLineProvenance')
}

/** POST /api/statements/getStatementLines */
export function useGetStatementLines<T = any>() {
  return useBackend<T>('statements/getStatementLines')
}

/** POST /api/statements/getStatementMatrix */
export function useGetStatementMatrix<T = any>() {
  return useBackend<T>('statements/getStatementMatrix')
}

/** POST /api/statements/getStatementPdfUrl */
export function useGetStatementPdfUrl<T = any>() {
  return useBackend<T>('statements/getStatementPdfUrl')
}

/** POST /api/statements/getStatementPeriods */
export function useGetStatementPeriods<T = any>() {
  return useBackend<T>('statements/getStatementPeriods')
}

/** POST /api/statements/getStatementRegenerationDeltas */
export function useGetStatementRegenerationDeltas<T = any>() {
  return useBackend<T>('statements/getStatementRegenerationDeltas')
}

/** POST /api/statements/getStatementWrites */
export function useGetStatementWrites<T = any>() {
  return useBackend<T>('statements/getStatementWrites')
}

/** POST /api/statements/getVehicleMissingDetail */
export function useGetVehicleMissingDetail<T = any>() {
  return useBackend<T>('statements/getVehicleMissingDetail')
}

/** POST /api/statements/getVehiclePerformance */
export function useGetVehiclePerformance<T = any>() {
  return useBackend<T>('statements/getVehiclePerformance')
}

/** POST /api/statements/getVehicleRecordShortage */
export function useGetVehicleRecordShortage<T = any>() {
  return useBackend<T>('statements/getVehicleRecordShortage')
}

/** POST /api/statements/getXeroSupport */
export function useGetXeroSupport<T = any>() {
  return useBackend<T>('statements/getXeroSupport')
}

/** POST /api/statements/regenerateDraftStatement */
export function useRegenerateDraftStatement<T = any>() {
  return useBackend<T>('statements/regenerateDraftStatement')
}

/** POST /api/statements/resolveStateDiscrepancy */
export function useResolveStateDiscrepancy<T = any>() {
  return useBackend<T>('statements/resolveStateDiscrepancy')
}

/** POST /api/statements/sendOwnerStatementEmail */
export function useSendOwnerStatementEmail<T = any>() {
  return useBackend<T>('statements/sendOwnerStatementEmail')
}

/** POST /api/statements/undoStateResolution */
export function useUndoStateResolution<T = any>() {
  return useBackend<T>('statements/undoStateResolution')
}

/** POST /api/statements/uploadScheduleDocument */
export function useUploadScheduleDocument<T = any>() {
  return useBackend<T>('statements/uploadScheduleDocument')
}

/** POST /api/statements/uploadSupportingDocument */
export function useUploadSupportingDocument<T = any>() {
  return useBackend<T>('statements/uploadSupportingDocument')
}
